<template>
  <div class="content-block l-container l-margin-bottom">
    <ModelOffers
      :model="props.pageData.model"
      :offer-filters="props.pageData.filters"
      :offers="props.pageData.offers"
      :changed-page="pageData.changedPage"
      :per-page="10"
      @set-filter="(e) => $emit('set-filter', e)"
      @change-data="(e) => $emit('change-data', e)"
      @change-model-sort-top3="$emit('change-model-sort-top3')"
    />
  </div>
  <div class="content-block l-container">
    <div v-if="props.seoData" class="l-description l-description-grid">
      <PageModelDescriptionModel :seo-data="props.seoData" />
    </div>
    <div v-if="accessories.length > 0" class="l-description-grid">
      <ModelSimilar
        :similar="accessories"
        title="Аксессуары"
        type="accessories"
        :show-more-button="false"
        :page-data="props.pageData"
        :model-id="props.pageData.model.id"
        :changed-page="props.pageData.changedPage"
        full-width-mobile
        @change-data="(e) => $emit('change-data', e)"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
const accessories = computed(() => props.pageData?.accessories || []);
defineEmits(['change-data', 'change-model-sort-top3', 'set-filter']);
const props = defineProps({
  pageData: {
    type: Object as () => any,
    required: true,
  },
  seoData: {
    type: Object as () => any,
    required: true,
  },
});
</script>
<style lang="scss" scoped>
.title {
  margin-bottom: 16px;
  @include md-block {
    margin-bottom: 24px;
  }
}
</style>
